<template>
  <div class="SpChoose" :disabled="disabledC">
    <input :id="serialID" ref="choose" v-model="model" :disabled="disabledC" hidden :checked="isCheck" :value="value" :type="inputType" :name="nameC" @click="change">
    <label v-if="labelPosition=='left'" :for="serialID" @click="labelClicked">
      <div class="label label-left pointer">
        <slot :isCheck="isCheck">{{ label||value }}</slot>
      </div>
      <div :class="iconClass" class="pointer" @click.capture="check">
        <div class="icon-inner" :class="{'sp-color-bg-1':checkIcon === 'radio'}" />
      </div>
    </label>
    <label v-if="labelPosition=='right'" :for="serialID" @click="labelClicked">
      <div :class="iconClass" :style="{width: width+'px', height: width + 'px'}" class="pointer" @click.capture="check">
        <!--        <span class="icon-gou iconfont" :class="{'sp-color-bg-1':checkIcon === 'radio'}" :style="{color: isCheck ? '#ffffff': 'rgba(0,0,0,0)', fontSize: width +'px'}" /> -->
        <div class="icon-inner" :class="{'sp-color-bg-1':checkIcon === 'radio', 'inner-12': width == 12}" :style="{}" />
      </div>
      <div class="label label-right pointer"><slot :isCheck="isCheck">{{ label||value }}</slot></div>
    </label>
  </div>
</template>

<script type="text/ecmascript-6">
import { computed, inject, nextTick, ref, toRef } from '@vue/runtime-core'
import useForm, { useFormItemProps } from '@/hooks/useForm'
import useModel from '@/hooks/useModel'
import { isNull } from '@/utils'
export default {
  name: 'SpChoose',

  nameSpace: 'SpChoose',

  components: {
  },

  props: {
    width: {
      type: Number,
      default: '15'
    },

    labelPosition: {
      type: String,
      default: 'right'
    },

    disabled: {
      type: Boolean,
      default: false
    },

    label: {
      type: String,
      default: ''
    },

    disableLabel: Boolean,

    iconType: {
      type: String,
      default: 'checkbox'
    },

    htmlName: {
      type: String,
      default: ''
    },

    value: {
      type: String,
      default: 'value'
    },

    type: {
      type: String,
      default: 'radio'
    },

    modelValue: {
      type: [String, Array],
      default: ''
    },

    cancelable: {
      type: Boolean,
      default: true
    },

    toClick: {
      type: Boolean,
      default: false
    },

    ...useFormItemProps()
  },

  emits: ['update:modelValue', 'label-click', 'radio-click'],
  setup (props, { emit }) {
    const chooseGroup = inject('chooseGroup')
    const isGroup = !!chooseGroup
    const choose = ref(null)

    const disabledC = computed(() => {
      return isGroup && !isNull(chooseGroup.disabled.value) ? chooseGroup.disabled.value : props.disabled
    })
    const model = useModel(toRef(props, 'modelValue'), emit, {
      get () {
        const value = formModel?.get?.(isGroup ? chooseGroup.name : props.name) || (isGroup ? chooseGroup.modelValue.value : props.modelValue)
        if (inputType.value === 'checkbox') {
          return value || []
        }
        return value || null
      },
      set (val) {
        // val = props.value
        isGroup ? chooseGroup.updateModelValue(val) : emit('update:modelValue', val)
        choose.value && (choose.value.checked = isCheck.value)
        if (formModel) {
          formModel.set(val, isGroup ? chooseGroup.name : props.name)
        }

        nextTick(() => {
          if (errorMsg.value && !validate()) {
            errorMsg.value = ''
          }
        })
      }
    })
    const { errorMsg, validate, formModel } = useForm(isGroup ? toRef(chooseGroup, 'name') : toRef(props, 'name'),
      isGroup ? chooseGroup.type : props.type || props.type,
      model,
      isGroup ? chooseGroup.required : props.required || props.required,
      isGroup ? chooseGroup.validateReg : props.validateReg || props.validateReg,
      isGroup ? chooseGroup.errorMsgFun : props.errorMsgFun || props.errorMsgFun)
    const inputType = computed(() => isGroup ? chooseGroup.type : props.type)
    const isCheck = computed(() => {
      if ((isGroup ? chooseGroup.type : props.type) === 'checkbox') {
        return Array.isArray(model.value) ? model.value.includes(props.value) : model.value === props.value
      }
      return model.value === props.value
    })
    const checkIcon = computed(() => isGroup ? chooseGroup.iconType : props.iconType)
    const cancelable = computed(() => isGroup ? chooseGroup.cancelable : props.cancelable)
    const iconClass = computed(() => {
      return {
        'checkbox-icon': checkIcon.value === 'checkbox',
        'sp-color-bg-1': isCheck.value && checkIcon.value === 'checkbox',
        'radio-icon': checkIcon.value === 'radio',
        'sp-color-bg-bd-1': isCheck.value && checkIcon.value === 'radio',
        'sp-color-error': !!errorMsg.value
      }
    })
    function genID (length) {
      return Number(Math.random().toString().substr(3, length) + Date.now()).toString(36)
    }
    const serialID = genID()// 默认生成的ID，唯一标识
    if (props.inputType === 'radio') {
      model.value = Array.isArray(model.value) ? (model.value[0] || '') : model.value
    }
    if (props.inputType === 'checkbox') {
      model.value = Array.isArray(model.value) ? model.value : [model.value]
    }
    const nameC = computed(() => isGroup ? chooseGroup.htmlName : props.htmlName)
    function change () {
      if (cancelable.value && model.value === props.value) {
        model.value = null
      }
    }

    function labelClicked (e) {
      if (props.disableLabel) {
        e.preventDefault()
      }
      if (props.toClick && !props.disabled) {
        emit('radio-click', model.value)
      }

      // 禁止取消选
      if ((props.cancelable && model.value === props.value)) return false
      emit('label-click', e)
    }

    function check () {
      if (props.disableLabel) {
        if (props.inputType === 'radio') {
          model.value = props.value
        } else if (props.inputType === 'checkbox') {
          if (model.value.includes(props.value)) {
            model.value.splice(model.value.indexOf(props.value), 1)
          } else {
            model.value.push(props.value)
          }
        }
      }
    }
    return {
      choose,
      model,
      errorMsg,
      validate,
      inputType,
      isCheck,
      checkIcon,
      iconClass,
      nameC,
      serialID,
      change,
      labelClicked,
      check,
      disabledC
    }
  }
}
</script>

<style scoped lang="less">
@gap:20px;
.SpChoose{
  position: relative;
  &[disabled='true'] :hover{
    cursor: not-allowed;
    label{
      color: red;
    }
    .checkbox-icon{
      border:1px solid #ccc;
    }
  }
  label{
    white-space:nowrap;
    display: flex;
    align-items: center;
    // >*{
    //   // display: inline-block;
    //   // display: flex;
    //   vertical-align: middle;
    //   text-overflow:ellipsis;
    // }
    .label{
      flex:1 1 200px;
    }
  }
  .label-right{
    margin-left: @gap/2;
  }
  .label-left{
    margin-right: @gap/2;
  }
  //checkbox 方框

  .checkbox-icon{
    display: inline-block;
    flex-shrink: 0;
    width: 15px;
    height:15px;
    border:1px solid gray;
    position: relative;
  }
  &[disabled='true']{
    label{
      .label{
        color: #000000 !important;
        opacity: 0.5;
      }
    }

    .checkbox-icon{
      border:1px solid #ccc;
    }
  }
  //checkbox-勾
  input:checked+label>.checkbox-icon>.icon-inner {
    position: absolute;
    content: "";
    width: 5px;
    height: 12px;
    top: -2px;
    left: 4px;
    border: 3px solid white;
    border-top: none;
    border-left: none;
    transform: rotate(47deg);
  }
  input:checked+label>.checkbox-icon>.icon-inner.inner-12 {
    position: absolute;
    content: "";
    width: 4px;
    height: 9px;
    top: -1px;
    left: 3px;
    border: 2px solid white;
    border-top: none;
    border-left: none;
    transform: rotate(47deg);

  }
  //radio-圆
  .radio-icon{
    display: inline-block;
    @size:14px;
    width: @size;
    height:@size;
    border-radius: @size;
    border:1px solid gray;
    position: relative;
  }
  //radio-内圆
  input:checked+label>.radio-icon>.icon-inner {
    position: absolute;
    left:50%;
    top:50%;
    transform: translate(-50%,-50%);
    @innersize:10px;
    width: @innersize;
    height: @innersize;
    border-radius: @innersize;
  }
}
</style>
